import { render, staticRenderFns } from "./bidList.vue?vue&type=template&id=788fcbd9&scoped=true&"
import script from "./bidList.vue?vue&type=script&lang=js&"
export * from "./bidList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788fcbd9",
  null
  
)

export default component.exports